// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { invRecipeId } from './InvRecipe';
import { invResourceId } from './InvResource';
import { z } from 'zod';
export const invRecipeStepId = (z.number());
export const invRecipeStep = z.object({
    id: invRecipeStepId,
    recipe_id: invRecipeId,
    step_number: z.number(),
    resource_id: invResourceId,
    quantity_fraction: z.number(),
    description: z.string().nullable(),
});
export const invRecipeStepInitializer = z.object({
    id: invRecipeStepId.optional(),
    recipe_id: invRecipeId,
    step_number: z.number(),
    resource_id: invResourceId,
    quantity_fraction: z.number(),
    description: z.string().optional().nullable(),
});
export const invRecipeStepMutator = z.object({
    id: invRecipeStepId.optional(),
    recipe_id: invRecipeId.optional(),
    step_number: z.number().optional(),
    resource_id: invResourceId.optional(),
    quantity_fraction: z.number().optional(),
    description: z.string().optional().nullable(),
});
//# sourceMappingURL=InvRecipeStep.js.map